import React, {ChangeEvent} from 'react';
import {Button} from 'antd';
import BatchInputFilterItem from '../../../delivery/components/BatchInputFilterItem';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import {CustomerServiceOrderFiltersType} from '../graphql/types/CustomerServiceOrderFiltersType';
import {t} from '../../../../i18n';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';

interface CustomerServiceParcelFilterProps {
    filters: CustomerServiceOrderFiltersType;
    setFilters: (filters: CustomerServiceOrderFiltersType) => void;
    handleFilter: () => void;
    handleResetFilters: () => void;
}

const CustomerServiceParcelFilter: React.FC<CustomerServiceParcelFilterProps> = ({
    filters,
    setFilters,
    handleFilter,
    handleResetFilters,
}) => {
    const labelClassName = useFilterLabelClassName();
    const containerClassName = useFilterContainerClassName();
    const inputContainerClassName = useFilterInputContainerClassName();

    return (
        <div className="mb-2 py-2">
            {/* 筛选条件区域 */}
            <div className="bg-gray-50 rounded-md px-4 py-4 mb-3">
                <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                    <div className="col-span-3">
                    <BatchInputFilterItem
                        label={t('customerservice.parcels.filters.tracking')}
                        value={filters.trackingNumbers}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setFilters({
                            ...filters,
                            trackingNumbers: e.target.value || undefined
                        })}
                            spanClassName="!w-[90px] !min-w-0 !flex-shrink-0 !font-bold"
                        placeholder={t('customerservice.parcels.placeholders.trackingNumbers') || ''}
                        rows={2}
                    />
                </div>
                    <div className="min-w-0">
                    <InputFilterItem
                        label={t('customerservice.parcels.filters.recipientPhone')}
                        value={filters.recipientPhone}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                            ...filters,
                            recipientPhone: e.target.value || undefined
                        })}
                            spanClassName="!w-[90px] !min-w-0 !flex-shrink-0 !font-bold"
                    />
                    </div>
                </div>
            </div>

            {/* 按钮区域 */}
            <div className="flex justify-end gap-2 mb-3">
                <Button 
                    type="primary" 
                    onClick={handleFilter}
                    className="w-auto min-w-24"
                >
                    <span className="font-bold">{t('components.button.filter')}</span>
                </Button>
                <Button 
                    onClick={handleResetFilters}
                    className="w-auto min-w-24"
                >
                    <span className="font-bold">{t('components.button.reset')}</span>
                </Button>
            </div>
        </div>
    );
};

export default CustomerServiceParcelFilter;

